import axios, {
  type AxiosError,
  type AxiosInstance,
  type AxiosResponse,
  HttpStatusCode
} from 'axios'
import { getAppUrl } from '@/utils'
import { notification } from 'ant-design-vue'
import { getAuthInfo, logout } from '@/apis/userInfoService.ts'
import type { ResponseBody } from '@/types'

export const httpClient: AxiosInstance = axios.create({
  baseURL: `${getAppUrl()}/api/cop`,
  timeout: 600 * 1000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    'X-App-Code': import.meta.env.VITE_CLIENT_ID
  },
  withCredentials: true
})

httpClient.interceptors.request.use(
  function (config) {
    /*const access_token: string | null =
      config?.data?.access_token || getItemFromLocalStorage(`${KEY_LOCAL}access_token`)
    if (access_token) {
      config.headers['Authorization'] = 'Bearer ' + access_token
    }*/
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
async function errorHandler(error: AxiosError): Promise<any> {
  // const notification = useNotification()
  const originalRequest = error.config
  console.log('error response: ', error.response)
  if (error.response) {
    const { data, status, statusText } = error.response as AxiosResponse<ResponseBody>
    if (
      status === HttpStatusCode.Unauthorized &&
      originalRequest &&
      originalRequest.url !== '/api/auth/info' &&
      originalRequest.url !== `${getAppUrl()}/api/auth/info`
    ) {
      const res = await getAuthInfo()
      if (!res || !res.accessToken) {
        await logout()
        notification?.error({
          message: '401',
          description: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại',
          duration: 3
        })
        return Promise.reject(error)
      }
      if (originalRequest) return httpClient.request(originalRequest)
    } else if (status === HttpStatusCode.Forbidden) {
      notification?.error({
        message: '403',
        description: data?.message || statusText,
        duration: 3
      })
    } else if (status === HttpStatusCode.InternalServerError) {
      notification?.error({
        message: '500',
        description: data?.message || statusText,
        duration: 3
      })
    } else {
      notification?.error({
        message: 'Thông báo',
        description: data?.message || statusText,
        duration: 3
      })
    }
  }
  return Promise.reject(error)
}
httpClient.interceptors.response.use(function (response) {
  return response
}, errorHandler)
